import { useContext, useMemo } from 'react';
import { TextureLoader, DoubleSide } from 'three';

import { GameContext, ViewContext } from '@/state/contexts';

// replace with texture of "Buy" in league spartan bold
// shows up in space above what would be next factory
// click to launch same buy factory model

const Sign3D = ({
	buttonAction = () => {},
	type = 'sign',
	playerId,
	p = [0, 11, 7.4],
}) => {
	const scale = 0.1;
	const buttonHeight = 36 * scale;
	const buttonWidth = 100 * scale;

	const pc: any = useContext(GameContext);

	let pos: [x: number, y: number, z: number] = [
		p[0] || 0,
		p[1] || 0,
		p[2] || 0,
	];

	const { payHereSignTexturePath }: any = useContext(ViewContext);

	const signPayHereTexture = useMemo(
		() => new TextureLoader().load(payHereSignTexturePath),
		[]
	);

	if (!pc) return;

	let buttonTexture = signPayHereTexture;

	// skip if it's not my turn, it's not my playermat or paymentMode

	return (
		<group>
			<mesh
				visible
				userData={{ hello: 'world' }}
				position={pos}
				rotation={[0, 0, 0]}
				onClick={(e) => {
					e.stopPropagation();
					buttonAction();
				}}
			>
				<boxGeometry args={[buttonWidth, buttonHeight, 0.1]} />
				<meshBasicMaterial
					attach="material"
					map={buttonTexture}
					side={DoubleSide}
				/>
			</mesh>
		</group>
	);
};

export default Sign3D;
